import { Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'u4-cpp-card',
    templateUrl: './card.component.html',
    styles: []
})
export class CardComponent {

    @Input() id: string;
    @Input() title: string;
    @Input() subtitle: string;
    @Input() body: string;
    @Input() footer = true;
    @Input() link: string[];
    @Input() disabled = false;

    @HostBinding() class = 'u4-card-container';

}
